import React from 'react';
import PropTypes from 'prop-types';
import Bar from './LoadingBar';
import Box from './LoadingBox';
import Circle from './Loading';

/**
 * 各种Loading样式
 */
export default function Loading(props) {
  const { type, ...others } = props;
  switch (type) {
    case 'bar':
      return <Bar {...others} />;
    case 'box':
      return <Box {...others} />;
    default:
      return <Circle {...others} />;
  }
}
Loading.defaultProps = {
  type: 'default',
  size: 'md',
  label: '加载中...',
  showLabel: true,
  align: 'vertical'
};
Loading.propTypes = {
  /** loaing的不同样式 */
  type: PropTypes.oneOf(['default', 'box', 'bar']),
  /** lg: 80\*80，md: 40\*40，sm: 20\*2，仅在type="default" 时才生效 */
  size: PropTypes.oneOf(['lg', 'md', 'sm']),
  /** loading旁边的内容，仅在type='default' 时才生效 */
  label: PropTypes.string,
  /** 是否显示label，仅在type='default' 时才生效 */
  showLabel: PropTypes.oneOf([true, false]),
  /** 文本对齐方式，仅在type='default' 时才生效 */
  align: PropTypes.oneOf(['vertical', 'horizontal'])
};
